import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/site/SEO";

export default function NotFoundPage({ onStartProject }) {
    return (
        <div
            className="relative pt-40 pb-32 min-h-[80vh] overflow-hidden"
            data-testid="page-not-found"
        >
            <SEO
                title="Page Not Found"
                description="The page you're looking for doesn't exist."
                path="/404"
                noindex
            />
            <div className="absolute inset-0 hero-radial pointer-events-none" />
            <div className="relative mx-auto max-w-3xl container-px text-center">
                <div className="text-[11px] font-mono uppercase tracking-[0.22em] text-[hsl(var(--text-subtle))]">
                    Error · 404
                </div>
                <h1 className="mt-4 font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.0] tracking-[-0.02em] text-[hsl(var(--text))]">
                    This page hasn’t been built… yet.
                </h1>
                <p className="mt-6 text-[16px] text-[hsl(var(--text-muted))] leading-relaxed">
                    The link you followed may be out of date — or the experience for it is still in design.
                </p>
                <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 rounded-full bg-white hover:bg-[hsl(var(--bg-2))] ring-1 ring-inset ring-black/10 text-[hsl(var(--text))] px-5 py-3 text-[14.5px] font-semibold transition-colors"
                    >
                        Back to home
                    </Link>
                    <button
                        type="button"
                        onClick={onStartProject}
                        className="sheen group inline-flex items-center gap-2 rounded-full bg-[hsl(var(--text))] hover:bg-[hsl(var(--text))]/90 text-[hsl(var(--bg))] px-5 py-3 text-[14.5px] font-semibold transition-colors"
                    >
                        Start a Project
                        <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
                    </button>
                </div>
            </div>
        </div>
    );
}
